/* RESPONSIBLE TEAM: team-inbox-experience */
import ApplicationAdapter from '../application';

export default ApplicationAdapter.extend({
  pathForType() {
    return 'inbox/admin_app_sidebar_sections/available_sections';
  },
});
